const BillingData = require('./BillingData');
const Bills = require('./Bills');
const Products = require('./Products');

const url = route('app.settings.financeiro.index');

function WizardEvents () {
  BillingData.init();
  Bills.init();
  Products.init();
};

module.exports = {
  url: [
    url.replace('/index', ''),
    url,
    route('app.conta-bloqueada'),
    route('app.periodo-teste-finalizado'),
    route('app.inicio.index')
  ],
  init: WizardEvents
}
